import { z } from 'zod';

export const INDUSTRY_OPTIONS = [
  'Technology',
  'Finance & Investment',
  'Media & Research',
  'Marketing',
  'Other',
] as const;

export const waitlistSignupSchema = z.object({
  id: z.string().uuid(),
  full_name: z.string().min(1),
  email: z.string().email(),
  industry: z.enum(INDUSTRY_OPTIONS),
  role: z.string().min(1),
  problem_description: z.string().nullable().optional(),
  rss_feeds_used: z.string().nullable().optional(),
  referral_token: z.string(),
  referral_source_token: z.string().nullable().optional(),
  created_at: z.string().datetime(),
});

export type WaitlistSignup = z.infer<typeof waitlistSignupSchema>;

export const createWaitlistSignupSchema = z.object({
  full_name: z.string().min(1, 'Full name is required'),
  email: z.string().email('Please enter a valid email address'),
  industry: z.enum(INDUSTRY_OPTIONS, {
    errorMap: () => ({ message: 'Please select an industry' }),
  }),
  role: z.string().min(1, 'Role is required'),
  problem_description: z.string().optional(),
  rss_feeds_used: z.string().optional(),
  referral_source_token: z.string().optional(),
});

export type CreateWaitlistSignup = z.infer<typeof createWaitlistSignupSchema>;
